import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from "../services/AuthService";

const authService = new AuthService();

const SignOutCallback: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        authService.userManager.signoutRedirect()
            .then(() => {
                // After calling `signoutRedirect`, the user will be redirected to the IdentityServer for logout.
                // After that, they might be redirected back to your application if you've configured a post-logout redirect.
                // So, you might need to handle that post-logout redirect if you've set one up.
                // If you haven't, this line might not be necessary.
                return authService.userManager.signoutRedirectCallback();
            })
            .then(() => {
                // Clean up any user/session data in your app if necessary.
                // Redirect to a page of your choice after logout.
                navigate('/');
            })
            .catch(error => {
                console.error("Error during signout:", error);
                navigate('/error');  // Redirect to an error page or handle the error differently.
            });
    }, [navigate]);

    return(
        <div>
            Processing sign-out...
            {/* Alternatively, display a spinner or other loading indicator here. */}
        </div>
    );
}

export default SignOutCallback;
